export class Condition {
  constructor(
    public antwoorden: VraagAntwoordId[],
    public linkt_naar: string) { }
}

export interface VraagAntwoordId {
  vraagId: string;
  antwoordId: string;
}
